/* Reading progress: a second-ink rule under the header */
(function () {
    'use strict';

    var bar = document.querySelector('[data-progress]');
    var content = document.querySelector('[data-content]');
    if (!bar || !content) {
        return;
    }

    var ticking = false;

    function update() {
        var rect = content.getBoundingClientRect();
        var total = rect.height - window.innerHeight * 0.5;
        var read = Math.min(Math.max(-rect.top + window.innerHeight * 0.25, 0), total);
        bar.style.setProperty('--progress', total > 0 ? (read / total).toFixed(4) : 0);
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            ticking = true;
            window.requestAnimationFrame(update);
        }
    }, {passive: true});

    update();
})();
